import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landingContent";
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-41" data-mp="197hnx54wne8v">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-42" data-mp="14eyaq9a4ql4l">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-white bg-cta px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(22,163,74,0.6)] transition-colors duration-150 ease-out hover:bg-cta-dark" data-id="element-43" data-mp="21cvvow3u7h9i">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-44" data-mp="1wb6mlm06ddo2" />
            Get Instant Access · $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}